// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__oNJqU","search":"Settings_search__2n__D","filter":"Settings_filter__3pDrL"};